export default __webpack_public_path__ + "static/Rashan-2a70a75bc1908642b8bf8c06e3e3e285.jpg";